const BASE_PATH = import.meta.env.VITE_BASE_PATH || '/';

/** Prefix a path with the Vite base path (e.g. /ai-coe/login). */
export function withBasePath(path: string): string {
  if (BASE_PATH === '/') return path;
  const base = BASE_PATH.endsWith('/') ? BASE_PATH.slice(0, -1) : BASE_PATH;
  return `${base}${path.startsWith('/') ? path : `/${path}`}`;
}

export function loginPath(): string {
  return withBasePath('/login');
}

export function assetPath(filename: string): string {
  return withBasePath(`/${filename.replace(/^\//, '')}`);
}

export function isLoginPath(): boolean {
  return window.location.pathname === loginPath() || window.location.pathname === '/login';
}
